import { gql } from 'graphql-request'

export const QuerySimpleBlock = gql`
  fragment FragmentSimpleBlock on SimpleContentBlockModelRecord {
    id
    icon
    title
    description {
      value
      links {
        ...FragmentLinkReferences
      }
      blocks {
        id
      }
    }
    action {
      ...FragmentNavigationItem
    }
    anchor
    bulletListColor
    bulletPoints {
        ...FragmentFormattedTextBlock
    }
  }
`
